import React, { Component } from 'react';
import Grid from '@mui/material/Grid';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';

const DateTimePicker = _props => {
  const props = { ..._props };
  props.sx ||= {};
  props.sx.width = 'calc(100% + 0.9rem)';

  const datePickerProps = {...props};
  const timePickerProps = {...props};

  if (props.value) {
    datePickerProps.value = timePickerProps.value = dayjs(props.value);
  }

  // dateLabel and dateHelperText are aliases for label and helperText,
  // or vice versa, but these all set the label and helper text on the date
  if (props.dateLabel) {
    datePickerProps.label = props.dateLabel;
  }
  if (props.dateHelperText) {
    datePickerProps.helperText = props.dateHelperText;
  }

  // timeLabel and timeHelperText must be used for the time input.
  // label and helperText only work on the date input
  timePickerProps.label = props.timeLabel;
  timePickerProps.helperText = props.timeHelperText;

  const setupHelperText = fieldProps => {
    if (fieldProps.helperText) {
      fieldProps.slotProps = {
        textField: {
          helperText: fieldProps.helperText
        }
      }
    }
  }
  setupHelperText(datePickerProps);
  setupHelperText(timePickerProps);

  const containerStyle = {
    width: '100%',
    marginTop: '0.5rem',
    marginBottom: '0.5rem'
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Grid container spacing={2} style={containerStyle}>
        <Grid item xs={6}>
          <DatePicker {...datePickerProps} />
        </Grid>
        <Grid item xs={6}>
          <TimePicker {...timePickerProps} />
        </Grid>
      </Grid>
    </LocalizationProvider>
  )
}

export default DateTimePicker;
